import React from 'react'
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../../../../../components/ui/alert-dialog';
import { Button } from '../../../../../components/ui/button';
import { capitalizeFirst } from '../../../../../commonUtils/string.helper';
import { ArrowDownTrayIcon } from '@heroicons/react/24/solid';
import { useDispatch, useSelector } from 'react-redux';
import { downloadFile } from '../../../../../store/uploads/actions';
import Spinner from '../../../../../components/Spinner';

const ViewDetails = ({
    open,
    handleClose,
    data
}) => {;
    const dispatch = useDispatch();
    const { downloadFileLoading } = useSelector((state) => state.Uploads);

    const handleDownload = async () => {
        if (!data?.fileName) return;
        dispatch(downloadFile({
            id: data._id,
            originalFileName: data?.fileOriginalName || `${data?.fileName || 'download'}.csv`
        }));
    };

    return (
        <AlertDialog open={open} onDismiss={handleClose}>
            <AlertDialogContent className="max-h-[80vh] overflow-y-auto overflow-x-hidden">
                <AlertDialogHeader className="flex flex-row justify-between space-0 mb-4">
                    <AlertDialogTitle className="text-lg flex-grow font-medium inline">
                        Upload Log Details
                    </AlertDialogTitle>
                    <button onClick={handleClose} className="bg-none border-none cursor-pointer text-sm">
                        ✕
                    </button>
                </AlertDialogHeader>
                <AlertDialogDescription className="hidden" />
                <div className="flex flex-col space-y-4 w-full min-w-0">
                    <p className="break-words"><strong>File name: </strong><span className="break-all">{data?.fileName}</span></p>
                    <p className="break-words"><strong>Original name: </strong><span className="break-all">{data?.fileOriginalName}</span></p>
                    <p className="break-words"><strong>Master Project: </strong>{data?.master_project}</p>
                    <p className="break-words"><strong>Project: </strong>{data?.project}</p>
                    <p className="break-words"><strong>Source Type: </strong>{data?.source_type}</p>
                    {data?.source_type === "Channel Partner" ? <p className="break-words"><strong>Channel Partner: </strong>{data?.channel_partner}</p> : <p className="break-words"><strong>Vendor: </strong>{data?.vendor}</p>}
                    <p className="break-words"><strong>SPOC: </strong>{data?.spoc}</p>
                    <p className="break-words"><strong>Uploaded By: </strong>{data?.uploaded_by}</p>
                    <p className="break-words"><strong>Data Category: </strong>{data?.data_category}</p>
                    <p className="break-words"><strong>Lead Source: </strong>{data?.lead_source}</p>
                    <p className="break-words"><strong>Reason of Procurement: </strong>{data?.proc_reason}</p>
                    <p className="break-words"><strong>Extracted On: </strong>{data?.extracted_on}</p>
                    <p className="break-words"><strong>Uploaded On: </strong>{data?.uploaded_on}</p>
                    <p className="break-words"><strong>Status: </strong>{capitalizeFirst(data?.status)}</p>
                    {data?.status === "Fields Rejected" && <p className="break-words"><strong>Remarks: </strong>{data?.remarks}</p>}
                    {data?.error_message && <p className="break-words"><strong>Error Details: </strong>{data?.error_message}</p>}
                    {data?.fileName && (
                        <p>
                            <strong>File: </strong>
                            <button 
                                onClick={handleDownload} 
                                className="inline-flex items-center ml-2 text-blue-600 hover:text-blue-800 cursor-pointer"
                                disabled={downloadFileLoading}
                            >
                                {downloadFileLoading ? <><Spinner container="h-5 w-[30px]"/>Downloading...</>
                                 : <><ArrowDownTrayIcon className="w-5 h-5 inline" />Download</>}
                            </button>
                        </p>
                    )}
                </div>
                <AlertDialogFooter>
                    <Button type="button" onClick={handleClose}>OK</Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}

export default ViewDetails